import React from 'react';
import Range from './range';

class Ranges extends React.Component {

  state = {
  }

  constructor(props) {
    super(props);
  }
  render() {
    return (
      <>
      {
        this.props.ranges.map(range => 
          <Range
            range={range}
          />
        )
      }
    </>
    )
  }
}

export default Ranges;